import { strCode } from "../consts";
import { t } from "../services";
import { selectFwuVersionToDelete, selectFwuVersionToEdit } from "../state/selectors";
import { getState } from "../state/store";

// Bin and signature file names are the same for all fwu versions on the backend
const BIN_FILE_NAME = "firmware.bin";
const SIGNATURE_FILE_NAME = "signature";

const splitVersion = (version) => {
  return version.split(".");
};

const formatFWUVersions = (fwuVersions) => {
  return fwuVersions?.map((version) => {
    const splittedVersion = splitVersion(version.version);

    const createdBy = {
      createdBy: version.created_by
        ? `${version.created_by.first_name} ${version.created_by.last_name}`
        : t(strCode.EMPTY_CELL_INFO),
      createdAt: version.created_date ?? t(strCode.EMPTY_CELL_INFO)
    };

    return {
      id: version.version,
      fwuName: version.version,
      fwuVersion: {
        major: splittedVersion[0],
        minor: splittedVersion[1],
        patch: splittedVersion[2]
      },
      deviceType: version.device_type,
      model: version.model,
      binFile: version?.firmwareExists ? { name: BIN_FILE_NAME, uploaded: true } : null,
      signatureFile: version?.signatureExists
        ? { name: SIGNATURE_FILE_NAME, uploaded: true }
        : null,
      createdBy: createdBy,
      isNew: false
    };
  });
};

const isVersionToEdit = (fwuVersion) => {
  const fwuVersionToEdit = selectFwuVersionToEdit()(getState());
  const isEditing = fwuVersionToEdit && fwuVersion?.fwuName === fwuVersionToEdit?.fwuName;

  return isEditing;
};

const isVersionToDelete = (fwuVersion) => {
  const fwuVersionToDelete = selectFwuVersionToDelete()(getState());
  const isDeleting = fwuVersionToDelete && fwuVersion?.fwuName === fwuVersionToDelete?.fwuName;

  return isDeleting;
};

const fwuVersionsUtil = { splitVersion, formatFWUVersions, isVersionToEdit, isVersionToDelete };

export default fwuVersionsUtil;
